import { render, staticRenderFns } from "./ModalCorrectionLetter.vue?vue&type=template&id=64c9e6a2&scoped=true"
import script from "./ModalCorrectionLetter.vue?vue&type=script&lang=js"
export * from "./ModalCorrectionLetter.vue?vue&type=script&lang=js"
import style0 from "./ModalCorrectionLetter.vue?vue&type=style&index=0&id=64c9e6a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c9e6a2",
  null
  
)

export default component.exports